import { IPropertyConverter, JsonValueObject, TaJson } from "ta-json";

import { MapStringTo } from "../base-types";
import { PageComponentResource } from "../models/pages/page-component-resource";

export class PageResourceZonesConverter implements IPropertyConverter {
    /**
     * Serializes a string map of arrays of {@link PageComponentResource}s.
     *
     * @param value - The map of strings to arrays of {@link PageComponentResource}s
     * @returns A JSON value object.
     */
    serialize(value: MapStringTo<Array<PageComponentResource>>): JsonValueObject {
        const result: JsonValueObject = {};

        Object.keys(value).forEach(zoneName => {
            const zone = value[zoneName];

            result[zoneName] = zone.map(pageComponentResource => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return TaJson.serialize(pageComponentResource);
            });
        });

        return result;
    }

    /**
     * Deserializes a JSON object into a string map of arrays of {@link PageComponentResource}s.
     *
     * @param value - A JSON object
     * @returns A mapping of strings to arrays of {@link PageComponentResource}s.
     */
    deserialize(value: JsonValueObject): MapStringTo<Array<PageComponentResource>> {
        if (!value) {
            return {};
        }

        const result: MapStringTo<Array<PageComponentResource>> = {};

        Object.keys(value).forEach(zoneName => {
            const zone = value[zoneName];
            if (Array.isArray(zone)) {
                result[zoneName] = zone.map(pageComponentResource => {
                    return TaJson.deserialize<PageComponentResource>(pageComponentResource, PageComponentResource);
                });
            }
        });

        return result;
    }
}
